import React, { useEffect } from "react";
import img from "../assets/com.webp";

type Post = {
  name: string;
  role: string;
  time: string;
  tag: string;
  title: string;
  seoTitle: string;
  desc: string;
  replies: number;
  likes: number;
  keywords: string;
};

type Group = {
  title: string;
  seoTitle: string;
  students: string;
  desc: string;
  image: string;
  category: string;
  href: string;
  alt: string;
  keywords: string;
};

type Challenge = {
  title: string;
  seoTitle: string;
  subject: string;
  questions: string;
  time: string;
  desc: string;
  keywords: string;
};

type Contributor = {
  name: string;
  points: string;
  badge: string;
  seoBadge: string;
};

type UpcomingEvent = {
  title: string;
  time: string;
  desc: string;
  keywords: string;
};

const posts: Post[] = [
  {
    name: "Aarav Sharma",
    role: "NEET Aspirant",
    time: "12 min ago",
    tag: "NEET Biology",
    title: "How should I revise Human Physiology for NEET?",
    seoTitle:
      "NEET Biology Human Physiology Revision Tips for Digestion and Respiration",
    desc: "I want to revise the Human Physiology chapter for NEET Biology, especially digestion and respiration. Can anyone suggest NCERT short notes, revision strategy or important questions?",
    replies: 18,
    likes: 42,
    keywords:
      "NEET Biology doubt, Human Physiology revision, digestion chapter NEET, respiration chapter NEET, NCERT Biology notes, NEET important questions",
  },
  {
    name: "Priya Verma",
    role: "Class 10 Student",
    time: "35 min ago",
    tag: "Class 10 Maths",
    title: "Tricky questions in Quadratic Equations",
    seoTitle:
      "Class 10 Maths Quadratic Equations Doubt for CBSE Board and Olympiad",
    desc: "How can I identify the difference between board-level and Olympiad-level questions in Class 10 Maths Quadratic Equations? What should be the best approach for CBSE exams?",
    replies: 11,
    likes: 27,
    keywords:
      "Class 10 Maths doubt, quadratic equations, CBSE Class 10 Maths, board exam preparation, Maths olympiad questions, NCERT Maths solutions",
  },
  {
    name: "Rohan Singh",
    role: "JEE Foundation",
    time: "1 hour ago",
    tag: "JEE Physics",
    title: "I am facing problems in Motion chapter numericals",
    seoTitle:
      "JEE Foundation Physics Motion Chapter Numericals and Formula Application",
    desc: "I remember the formulas of the Motion chapter, but I get confused while solving JEE Foundation numericals. How can I improve my question approach and step-by-step solving method?",
    replies: 24,
    likes: 51,
    keywords:
      "JEE Physics doubt, Motion chapter numericals, JEE Foundation Physics, Class 9 Physics motion, Class 10 Physics numericals, Physics formula application",
  },
];

const groups: Group[] = [
  {
    title: "NEET Warriors",
    seoTitle: "NEET UG Biology Chemistry Physics Doubt Solving Group",
    students: "12.5k Students",
    desc: "An active study group for NEET UG aspirants to discuss Biology, Chemistry and Physics doubts, NCERT revision, daily practice questions and mentor guidance.",
    category: "NEET UG",
    href: "/login",
    image:
      "https://images.unsplash.com/photo-1532635241-17e820acc59f?auto=format&fit=crop&w=900&q=80",
    alt: "NEET UG online study group for Biology Chemistry Physics doubts and NCERT preparation",
    keywords:
      "NEET study group, NEET Biology doubts, NEET Chemistry questions, NEET Physics practice, NEET UG preparation, medical entrance online community",
  },
  {
    title: "JEE Foundation",
    seoTitle: "JEE Main Foundation Maths Physics Practice Group",
    students: "8.2k Students",
    desc: "A focused group for JEE Main foundation students to practice Maths, Physics, daily numericals, formula application and exam pattern based problem solving.",
    category: "JEE Main",
    href: "/login",
    image:
      "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=900&q=80",
    alt: "JEE Main foundation study group for Maths Physics numericals and online practice",
    keywords:
      "JEE Main foundation, JEE Maths practice, JEE Physics numericals, IIT JEE preparation, engineering entrance community, JEE online study group",
  },
  {
    title: "Class 7-10 Scholars",
    seoTitle: "Class 7 to 10 CBSE NCERT School Exam and Olympiad Group",
    students: "15k Students",
    desc: "A learning circle for Class 7, Class 8, Class 9 and Class 10 students to improve school exam preparation, CBSE NCERT concepts, Maths, Science and Olympiad practice.",
    category: "School",
    href: "/login",
    image:
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=900&q=80",
    alt: "Class 7 to 10 online study group for CBSE NCERT Maths Science and Olympiad preparation",
    keywords:
      "Class 7 online study, Class 8 tuition, Class 9 Science doubts, Class 10 Maths preparation, CBSE NCERT study group, Olympiad preparation",
  },
];

const contributors: Contributor[] = [
  {
    name: "Ananya",
    points: "8,450 pts",
    badge: "Top Doubt Solver",
    seoBadge: "Top student mentor for doubt solving and study guidance",
  },
  {
    name: "Kabir",
    points: "7,980 pts",
    badge: "Physics Expert",
    seoBadge: "Physics expert for JEE Foundation and school numericals",
  },
  {
    name: "Meera",
    points: "6,720 pts",
    badge: "Biology Mentor",
    seoBadge: "Biology mentor for NEET NCERT revision and concept clarity",
  },
];

const challenges: Challenge[] = [
  {
    title: "Biology NCERT Rapid Quiz",
    seoTitle: "NEET Biology NCERT Rapid Quiz for Chapter Revision",
    subject: "NEET Biology",
    questions: "25 Questions",
    time: "20 Min",
    desc: "A rapid NCERT Biology quiz for NEET aspirants to revise Human Physiology, Genetics, Ecology and other important Biology concepts.",
    keywords:
      "NEET Biology quiz, NCERT Biology test, NEET chapter revision, Biology MCQ practice, medical entrance test practice",
  },
  {
    title: "Physics Motion Practice",
    seoTitle: "JEE Foundation Physics Motion Numericals Practice Test",
    subject: "JEE Foundation",
    questions: "15 Numericals",
    time: "30 Min",
    desc: "A concept-based Physics practice test for JEE Foundation and Class 9-10 students covering Motion chapter numericals and formula application.",
    keywords:
      "Physics motion numericals, JEE Foundation test, Class 9 Physics practice, Class 10 Physics motion, Physics MCQ questions",
  },
];

const upcomingEvents: UpcomingEvent[] = [
  {
    title: "NEET Biology Marathon",
    time: "Today • 7:00 PM",
    desc: "NCERT Biology revision session for NEET UG aspirants.",
    keywords:
      "NEET Biology live class, NCERT Biology marathon, NEET revision session",
  },
  {
    title: "JEE Maths Practice Battle",
    time: "Tomorrow • 6:30 PM",
    desc: "JEE Maths problem solving and speed practice session.",
    keywords:
      "JEE Maths practice, JEE Main Maths questions, IIT JEE problem solving",
  },
  {
    title: "Class 10 Science Quiz",
    time: "Sunday • 11:00 AM",
    desc: "CBSE Class 10 Science quiz for Physics, Chemistry and Biology concepts.",
    keywords:
      "Class 10 Science quiz, CBSE Science test, NCERT Science practice",
  },
];

const seoKeywords = [
  "Mediit Academy community",
  "online learning community for students",
  "student doubt solving platform",
  "NEET Biology doubt group",
  "NEET UG preparation community",
  "JEE Main study group",
  "JEE Foundation Physics Maths",
  "Class 7 online study group",
  "Class 8 online tuition support",
  "Class 9 Maths Science doubts",
  "Class 10 CBSE board preparation",
  "Class 11 JEE NEET preparation",
  "Class 12 board exam preparation",
  "CBSE NCERT online learning",
  "NCERT notes and solutions",
  "online mock test series",
  "daily quiz for students",
  "Maths doubt solving",
  "Physics numericals practice",
  "Chemistry questions discussion",
  "Biology NCERT revision",
  "Olympiad preparation",
  "school exam preparation",
  "live online classes",
  "study notes",
  "mentor guidance",
  "exam preparation community",
].join(", ");

const Community: React.FC = () => {
  useEffect(() => {
    const title =
      "Student Learning Community | NEET, JEE, CBSE, NCERT Doubt Solving - Mediit Academy";

    const description =
      "Join Mediit Academy student learning community for NEET Biology doubts, JEE Physics Maths practice, Class 7 to 10 CBSE NCERT study groups, mock tests, quizzes, study notes and mentor guidance.";

    document.title = title;

    const setMetaTag = (name: string, content: string) => {
      let tag = document.querySelector(
        `meta[name="${name}"]`
      ) as HTMLMetaElement | null;

      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }

      tag.setAttribute("content", content);
    };

    const setPropertyTag = (property: string, content: string) => {
      let tag = document.querySelector(
        `meta[property="${property}"]`
      ) as HTMLMetaElement | null;

      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }

      tag.setAttribute("content", content);
    };

    setMetaTag("description", description);
    setMetaTag("keywords", seoKeywords);
    setMetaTag("robots", "index, follow");
    setMetaTag("author", "Mediit Academy");

    setPropertyTag("og:title", title);
    setPropertyTag("og:description", description);
    setPropertyTag("og:type", "website");
    setPropertyTag("og:site_name", "Mediit Academy");

    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", title);
    setMetaTag("twitter:description", description);

    let canonical = document.querySelector(
      `link[rel="canonical"]`
    ) as HTMLLinkElement | null;

    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }

    canonical.setAttribute("href", `${window.location.origin}/community`);
  }, []);

  const communitySchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Mediit Academy Student Learning Community",
    description:
      "Online student community for NEET UG, JEE Main, CBSE, NCERT, Class 7 to 12, doubt solving, study groups, mock tests, quizzes and mentor guidance.",
    url: "/community",
    about: [
      "NEET Biology Doubt Solving",
      "JEE Physics Maths Practice",
      "CBSE NCERT Study Groups",
      "Class 7 to 10 School Preparation",
      "Class 10 Board Exam Preparation",
      "Mock Test Series",
      "Daily Quiz",
      "Online Learning Community",
    ],
    mainEntity: {
      "@type": "ItemList",
      name: "Student Study Groups and Discussion Topics",
      itemListElement: [
        ...groups.map((group, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: group.seoTitle,
          description: group.desc,
          url: group.href,
        })),
        ...posts.map((post, index) => ({
          "@type": "ListItem",
          position: groups.length + index + 1,
          name: post.seoTitle,
          description: post.desc,
        })),
      ],
    },
  };

  return (
    <main className="min-h-screen bg-slate-50 font-['Inter'] text-slate-900">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(communitySchema),
        }}
      />

      {/* Hero Section */}
      <section
        className="relative overflow-hidden bg-gradient-to-br from-[#07111b] via-[#111936] to-[#1e3a5f] px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20"
        aria-labelledby="community-hero-heading"
      >
        <div className="absolute -left-20 top-10 h-64 w-64 rounded-full bg-blue-500/20 blur-3xl" />
        <div className="absolute -right-20 bottom-0 h-72 w-72 rounded-full bg-cyan-400/20 blur-3xl" />

        <div className="relative mx-auto grid max-w-7xl items-center gap-10 lg:grid-cols-2">
          {/* Left Content */}
          <div className="text-center lg:text-left">
            <span className="inline-flex rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-semibold text-cyan-100 backdrop-blur sm:text-sm">
              Mediit Academy Learning Community
            </span>

            <h1
              id="community-hero-heading"
              className="mt-6 text-3xl font-black leading-tight text-white sm:text-5xl lg:text-6xl"
            >
              Student Community for NEET, JEE, CBSE, NCERT and Doubt Solving
            </h1>

            <p className="mx-auto mt-5 max-w-xl text-sm leading-7 text-slate-200 sm:text-base lg:mx-0 lg:text-lg">
              Ask your Maths, Physics, Chemistry, Biology, NCERT, CBSE board
              exam, JEE Main and NEET UG doubts, get guidance from mentors, join
              active study groups and improve your preparation with daily
              learning challenges.
            </p>

            <p className="sr-only">{seoKeywords}</p>

            <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row lg:justify-start">
              <a
                href="/login"
                aria-label="Ask your study doubt for NEET JEE CBSE NCERT Maths Physics Chemistry Biology"
                className="rounded-2xl bg-cyan-400 px-6 py-3 text-sm font-black text-slate-950 shadow-lg shadow-cyan-500/30 transition hover:-translate-y-0.5 hover:bg-cyan-300"
              >
                Ask Your Doubt
              </a>

              <a
                href="/login"
                aria-label="Join online study group for NEET JEE Class 7 to 10 CBSE and NCERT preparation"
                className="rounded-2xl border border-white/20 bg-white/10 px-6 py-3 text-sm font-bold text-white backdrop-blur transition hover:bg-white/20"
              >
                Join Study Group
              </a>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative mx-auto w-full max-w-[620px]">
            <div className="absolute -left-5 -top-5 h-24 w-24 rounded-full bg-cyan-400/30 blur-2xl" />
            <div className="absolute -bottom-5 -right-5 h-32 w-32 rounded-full bg-blue-500/30 blur-2xl" />

            <div className="relative flex min-h-[300px] items-center justify-center sm:min-h-[390px] lg:min-h-[470px]">
              <img
                src={img}
                alt="Mediit Academy online student learning community for NEET JEE CBSE NCERT doubt solving and study groups"
                loading="eager"
                decoding="async"
                className="relative z-10 h-auto max-h-[300px] w-full object-contain drop-shadow-2xl sm:max-h-[390px] lg:max-h-[470px]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section
        className="mx-auto grid max-w-7xl gap-8 px-4 py-10 sm:px-6 sm:py-12 lg:grid-cols-12 lg:px-8"
        aria-label="Mediit Academy study groups, student doubts, daily challenges and mentor support"
      >
        {/* Left Content */}
        <div className="lg:col-span-8">
          {/* Groups */}
          <div>
            <div className="mb-6 flex items-end justify-between gap-4">
              <div>
                <p className="text-xs font-black uppercase tracking-wide text-blue-600 sm:text-sm">
                  Study Groups for Students
                </p>
                <h2 className="mt-1 text-2xl font-black text-slate-950 sm:text-3xl">
                  Join NEET, JEE, CBSE and NCERT Learning Groups
                </h2>
              </div>

              <a
                href="/login"
                aria-label="View all study groups for NEET JEE CBSE NCERT and school students"
                className="hidden rounded-xl bg-slate-950 px-4 py-2 text-sm font-bold text-white sm:block"
              >
                View All
              </a>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
              {groups.map((group) => (
                <article
                  key={group.title}
                  className="group overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-slate-200 transition duration-300 hover:-translate-y-1 hover:shadow-xl"
                  title={group.seoTitle}
                >
                  <div className="relative h-44 overflow-hidden sm:h-40">
                    <img
                      src={group.image}
                      alt={group.alt}
                      loading="lazy"
                      decoding="async"
                      className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-110"
                    />

                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/30 to-transparent" />

                    <span className="absolute left-4 top-4 rounded-full bg-white/95 px-3 py-1 text-xs font-black text-blue-600 shadow-sm backdrop-blur">
                      {group.category}
                    </span>

                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="text-xl font-black text-white">
                        {group.title}
                      </h3>
                      <p className="mt-1 text-sm font-bold text-cyan-100">
                        {group.students}
                      </p>
                    </div>
                  </div>

                  <div className="p-5">
                    <p className="text-sm font-bold text-blue-700">
                      {group.seoTitle}
                    </p>

                    <p className="mt-2 min-h-[72px] text-sm leading-6 text-slate-600">
                      {group.desc}
                    </p>

                    <p className="sr-only">{group.keywords}</p>

                    <a
                      href={group.href}
                      aria-label={`Join ${group.seoTitle}. Keywords: ${group.keywords}`}
                      className="mt-5 flex w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-slate-950 to-blue-700 px-4 py-3 text-sm font-black text-white shadow-lg shadow-blue-900/20 transition hover:-translate-y-0.5 hover:from-blue-700 hover:to-cyan-600"
                    >
                      Join Group
                      <span className="text-base" aria-hidden="true">
                        →
                      </span>
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {/* Daily Challenge */}
          <div className="mt-12 rounded-[2rem] bg-gradient-to-br from-slate-950 via-blue-950 to-slate-900 p-5 text-white shadow-xl sm:p-7">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <p className="text-xs font-black uppercase tracking-wide text-cyan-300 sm:text-sm">
                  Daily Quiz and Practice Challenge
                </p>
                <h2 className="mt-1 text-2xl font-black sm:text-3xl">
                  Practice NEET, JEE, Maths, Science and NCERT Questions
                </h2>
                <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-300">
                  Solve new MCQ questions, Physics numericals, Biology NCERT
                  quizzes, Maths practice problems and leaderboard challenges
                  every day. Regular practice helps students strengthen board
                  exam, JEE Main and NEET UG preparation.
                </p>
              </div>

              <a
                href="/login"
                aria-label="Start daily practice test for NEET JEE CBSE NCERT Maths Science questions"
                className="rounded-2xl bg-cyan-400 px-5 py-3 text-center text-sm font-black text-slate-950 hover:bg-cyan-300"
              >
                Start Practice
              </a>
            </div>

            <div className="mt-6 grid gap-4 sm:grid-cols-2">
              {challenges.map((challenge) => (
                <article
                  key={challenge.title}
                  className="rounded-3xl border border-white/10 bg-white/10 p-5 backdrop-blur"
                  title={challenge.seoTitle}
                >
                  <p className="text-xs font-black uppercase tracking-wide text-cyan-200">
                    {challenge.subject}
                  </p>

                  <h3 className="mt-2 text-lg font-black">
                    {challenge.title}
                  </h3>

                  <p className="mt-2 text-sm leading-6 text-slate-300">
                    {challenge.desc}
                  </p>

                  <p className="sr-only">{challenge.keywords}</p>

                  <div className="mt-4 flex flex-wrap gap-2">
                    <span className="rounded-full bg-white/10 px-3 py-1 text-xs font-bold text-slate-100">
                      {challenge.questions}
                    </span>
                    <span className="rounded-full bg-white/10 px-3 py-1 text-xs font-bold text-slate-100">
                      {challenge.time}
                    </span>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {/* Discussion Feed */}
          <div className="mt-12">
            <div className="mb-6 flex items-center justify-between gap-4">
              <div>
                <p className="text-xs font-black uppercase tracking-wide text-blue-600 sm:text-sm">
                  Student Doubt Discussions
                </p>
                <h2 className="mt-1 text-2xl font-black text-slate-950 sm:text-3xl">
                  Latest NEET, JEE, Maths, Science and Board Exam Doubts
                </h2>
              </div>

              <a
                href="/login"
                aria-label="Post your study doubt for mentor and student answers"
                className="rounded-xl bg-blue-600 px-4 py-2 text-xs font-bold text-white shadow-sm hover:bg-blue-700 sm:text-sm"
              >
                Post Doubt
              </a>
            </div>

            <div className="space-y-5">
              {posts.map((post) => (
                <article
                  key={post.title}
                  className="rounded-3xl bg-white p-5 shadow-sm ring-1 ring-slate-200 transition hover:shadow-lg"
                  title={post.seoTitle}
                >
                  <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                    <div className="flex gap-4">
                      <div
                        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-500 to-cyan-500 text-lg font-black text-white"
                        aria-hidden="true"
                      >
                        {post.name.charAt(0)}
                      </div>

                      <div>
                        <h3 className="font-black text-slate-950">
                          {post.name}
                        </h3>
                        <p className="text-sm font-medium text-slate-500">
                          {post.role} • {post.time}
                        </p>
                      </div>
                    </div>

                    <span className="w-fit rounded-full bg-blue-50 px-3 py-1 text-xs font-black text-blue-600">
                      {post.tag}
                    </span>
                  </div>

                  <h4 className="mt-5 text-lg font-black text-slate-950 sm:text-xl">
                    {post.title}
                  </h4>

                  <p className="mt-2 text-sm font-bold text-blue-700">
                    {post.seoTitle}
                  </p>

                  <p className="mt-2 text-sm leading-6 text-slate-600">
                    {post.desc}
                  </p>

                  <p className="sr-only">{post.keywords}</p>

                  <div className="mt-5 flex flex-wrap gap-3 border-t border-slate-100 pt-4">
                    <button
                      type="button"
                      className="rounded-xl bg-slate-50 px-4 py-2 text-sm font-bold text-slate-600 hover:bg-slate-100"
                      aria-label={`${post.likes} students liked this ${post.tag} doubt`}
                    >
                      ❤️ {post.likes} Likes
                    </button>

                    <button
                      type="button"
                      className="rounded-xl bg-slate-50 px-4 py-2 text-sm font-bold text-slate-600 hover:bg-slate-100"
                      aria-label={`${post.replies} replies on this student doubt`}
                    >
                      💬 {post.replies} Replies
                    </button>

                    <a
                      href="/login"
                      aria-label={`Answer doubt: ${post.seoTitle}`}
                      className="rounded-xl bg-slate-950 px-4 py-2 text-sm font-bold text-white hover:bg-blue-600"
                    >
                      Answer Doubt
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>

        {/* Right Sidebar */}
        <aside className="space-y-6 lg:sticky lg:top-24 lg:col-span-4 lg:self-start">
          {/* Ask Doubt Card */}
          <div className="rounded-3xl bg-gradient-to-br from-slate-950 to-blue-950 p-6 text-white shadow-xl">
            <p className="text-sm font-black uppercase tracking-wide text-cyan-300">
              Need Help with Studies?
            </p>

            <h3 className="mt-2 text-2xl font-black">
              Ask Maths, Science, NEET, JEE or Board Exam Doubts
            </h3>

            <p className="mt-3 text-sm leading-6 text-slate-300">
              Post your question and get step-by-step explanations from mentors
              and students. Get quick support for Physics numericals, Chemistry
              concepts, Biology NCERT topics, Maths problems and CBSE board
              doubts.
            </p>

            <a
              href="/login"
              aria-label="Ask study doubt and get quick answers from mentors and students"
              className="mt-6 block w-full rounded-2xl bg-cyan-400 px-4 py-3 text-center text-sm font-black text-slate-950 hover:bg-cyan-300"
            >
              Ask Now
            </a>
          </div>

          {/* Upcoming Events */}
          <div className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
            <h3 className="text-xl font-black text-slate-950">
              Upcoming Live Study Events
            </h3>

            <div className="mt-5 space-y-4">
              {upcomingEvents.map((event) => (
                <article
                  key={event.title}
                  className="rounded-2xl bg-slate-50 p-4 transition hover:bg-blue-50"
                  title={event.keywords}
                >
                  <p className="text-sm font-black text-slate-950">
                    {event.title}
                  </p>
                  <p className="mt-1 text-sm text-slate-500">{event.time}</p>
                  <p className="mt-2 text-xs leading-5 text-slate-500">
                    {event.desc}
                  </p>
                  <p className="sr-only">{event.keywords}</p>
                </article>
              ))}
            </div>
          </div>

          {/* Top Contributors */}
          <div className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
            <h3 className="text-xl font-black text-slate-950">
              Top Student Contributors
            </h3>

            <div className="mt-5 space-y-4">
              {contributors.map((item, index) => (
                <article
                  key={item.name}
                  className="flex items-center gap-4 rounded-2xl bg-slate-50 p-4 transition hover:bg-blue-50"
                  title={item.seoBadge}
                >
                  <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white text-sm font-black text-slate-950 shadow-sm">
                    #{index + 1}
                  </div>

                  <div>
                    <p className="font-black text-slate-950">{item.name}</p>
                    <p className="text-sm font-medium text-slate-500">
                      {item.badge}
                    </p>
                    <p className="text-xs font-bold text-blue-600">
                      {item.points}
                    </p>
                    <p className="sr-only">{item.seoBadge}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {/* Rules */}
          <div className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
            <h3 className="text-xl font-black text-slate-950">
              Community Rules for Students
            </h3>

            <ul className="mt-5 space-y-3 text-sm leading-6 text-slate-600">
              <li className="flex gap-3">
                <span className="font-black text-emerald-500">✓</span>
                Respect all students, teachers, mentors and doubt solvers.
              </li>
              <li className="flex gap-3">
                <span className="font-black text-emerald-500">✓</span>
                Post doubts clearly with the correct subject: Maths, Physics,
                Chemistry, Biology, English, Reasoning or NCERT.
              </li>
              <li className="flex gap-3">
                <span className="font-black text-emerald-500">✓</span>
                Avoid spam, copied answers and irrelevant content.
              </li>
              <li className="flex gap-3">
                <span className="font-black text-emerald-500">✓</span>
                Like helpful answers, notes, solutions and explanations.
              </li>
            </ul>
          </div>
        </aside>
      </section>
    </main>
  );
};

export default Community;